module.exports = __webpack_public_path__ + "static/media/digital-marketing.347d7cfb.png";